const defaultLanguage = 'en'

module.exports = defaultLanguage
